import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';

const ScrollableReviewSection = ({
  title,
  header,
  children,
  listAriaLabel,
  borderRadius = '20px',
}) => (
  <Box
    sx={{
      borderRadius,
      bgcolor: '#FFFFFF',
      boxShadow: '0 10px 24px rgba(41, 54, 46, 0.08)',
      border: `1px solid ${alpha(colors.brand.deep, 0.12)}`,
      overflow: 'hidden',
    }}
  >
    <Box
      component="header"
      sx={{
        position: 'relative',
        zIndex: 1,
        p: { xs: 1.1, sm: 1.35 },
        bgcolor: '#FFFFFF',
        borderBottom: `1px solid ${alpha(colors.brand.deep, 0.12)}`,
      }}
    >
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography sx={{ fontSize: '0.76rem', fontWeight: 950, color: colors.brand.deep, letterSpacing: 0.8, textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
            {title}
          </Typography>
          <Box sx={{ height: 1, bgcolor: alpha(colors.brand.deep, 0.16), flex: 1 }} />
        </Stack>
        {header}
      </Stack>
    </Box>

    <Box
      role="region"
      aria-label={listAriaLabel}
      sx={{
        maxHeight: { xs: 360, sm: 420 },
        overflowY: 'auto',
        overflowX: 'hidden',
        scrollBehavior: 'smooth',
        WebkitOverflowScrolling: 'touch',
        overscrollBehaviorY: 'contain',
        border: 0,
        borderRadius: 0,
        boxShadow: 'none',
        bgcolor: 'transparent',
        px: { xs: 1.5, md: 2 },
        py: 1.5,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default ScrollableReviewSection;
